<template>
  <div class="dashboard-container">
    <!-- Loader: Top Progress Bar -->
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>

    <div class="container">
      <!-- Form Title -->
      <div class="mb-2 page-title">
        <i class="bi bi-file-earmark-text"></i>
        {{ isEdit ? "Ubah Narahubung" : "Tambah Narahubung" }}
      </div>

      <!-- Form -->
      <form @submit.prevent="submitForm" class="admin-form mt-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <label for="tournament_id" class="form-label">Turnamen</label>
              <select
                class="form-select"
                id="tournament_id"
                v-model="form.tournament_id"
                :class="{ 'is-invalid': errors.tournament_id }"
              >
                <option value="" disabled>Pilih Turnamen</option>
                <option 
                  v-for="tournament in allTournaments" 
                  :key="tournament.id" 
                  :value="tournament.id"
                >
                  {{ tournament.name }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.tournament_id }}</div>
            </div>
            <div class="mb-3">
              <label for="name" class="form-label">Nama Narahubung</label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.name }"
                id="name"
                v-model="form.name"
              />
              <div class="invalid-feedback">{{ errors.name }}</div>
            </div>
            <div class="mb-3">
              <label for="description" class="form-label">Keterangan</label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.description }"
                id="name"
                v-model="form.description"
              />
              <div class="invalid-feedback">{{ errors.description }}</div>
            </div>
            <div class="mb-3">
              <label for="phone" class="form-label">Telepon</label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.phone }"
                id="phone"
                v-model="form.phone"
              />
              <div class="invalid-feedback">{{ errors.phone }}</div>
            </div>

            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.email }"
                id="email"
                v-model="form.email"
              />
              <div class="invalid-feedback">{{ errors.email }}</div>
            </div>
          </div>
        </div>
  
        <!-- Submit Button -->
        <div class="row">
          <div class="col-lg-12 text-center">
            <button type="submit" class="button button-primary" :disabled="loading">
              <i class="bi bi-floppy"></i>
              <span>{{ isEdit ? "Simpan Perubahan" : "Tambah Narahubung" }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ratakanGalat } from '@/utils/galatForm';
import axios from "axios";
import { useToast } from "vue-toastification";

export default {
  name: "ContactPersonForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      contactPersonId: null,
      allTournaments: [],
      form: {
        tournament_id: "",
        name: "",
        description: "",
        phone: "",
        email: "",
      },
      errors: {},
      loading: false,
      progress: 0,
    };
  },

  created() {
    this.contactPersonId = this.$route.params.id;
    this.fetchActiveTournaments();
    if (this.isEdit && this.contactPersonId) {
      this.fetchContactPersonDetail(this.contactPersonId);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.isEdit && to.params.id !== this.contactPersonId) {
      this.memberId = to.params.id;
      this.fetchContactPersonDetail(this.memberId);
    }
    next();
  },

  watch: {
    // Watch for changes to the memberId from the route params
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        // Fetch contingent data when route param changes
        if (this.isEdit && newId) {
          this.memberId = newId;
          this.fetchContactPersonDetail(newId); 
        }
      },
    }
  },

  methods: {

    async fetchActiveTournaments() {
      await this.fetchData("/tournaments/all", "allTournaments");
    },

    async fetchData(url, targetKey) {
      try {
        const response = await axios.get(url);
        this[targetKey] = response.data;
      } catch (error) {
        this.toast.error("Gagal memuat pilihan. Muat ulang halaman.");
      }
    },
    async fetchContactPersonDetail(id) {
      this.loading = true;
      try {
        const response = await axios.get(
          `/tournament-contact-persons/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('authToken')}`
            }
          }
        );
        if (response.data) {
          const detail = response.data.data;
          this.form = {
            tournament_id : detail.tournament_id || "",
            name: detail.name || null,
            description: detail.description || "",
            phone: detail.phone || null,
            email: detail.email || null,
          };

          
        }
      } catch (error) {
        this.toast.error("Gagal memuat data. Muat ulang halaman.");
        console.error("Error fetching class details:", error);
      } finally {
        this.loading = false;
      }
    },

    
    async submitForm() {
      this.loading = true;

      try {
        const endpoint = this.isEdit ? `/tournament-contact-persons/${this.contactPersonId}` : "/tournament-contact-persons";
        const method = this.isEdit ? "put" : "post";

        await axios[method](
          endpoint,
          this.form,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Add Authorization header
            },
          }
        );

        this.toast.success(this.isEdit ? "Narahubung berhasil diperbarui." : "Narahubung berhasil ditambahkan.");
        this.$router.push("/admin/contact-person");
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = ratakanGalat(error.response.data.errors);
          this.toast.error("Periksa kembali isian yang ditandai merah.");
        } else {
          this.toast.error(error?.response?.data?.message || "Gagal menyimpan. Coba lagi.");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>


<style scoped>

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

.page-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.invalid-feedback {
  display: block;
  color: #dc3545;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
